module.exports = __webpack_public_path__ + "img/accidentes.b668c7d9.png";